import CollectionDataGrid from '@/components/CollectionDataGrid'
import { useCollection } from '@/pb'
import { objectMap } from '@/utils'
import { Button } from '@mui/material'
import { useMemo } from 'react'

const setUsed = (rfid, used) => () => {
  pb.collection('claimedLabels').update(rfid, { used })
}

const UsedButton = ({ rfid, used }) => (
  <Button
    onClick={setUsed(rfid, !used)}
    color={used ? 'primary' : 'success'}
    variant={used ? 'text' : 'contained'}
  >
    {used ? 'Использована' : 'Не использована'}
  </Button>
)

const columns = [
  { field: 'id', headerName: 'Короткий код', width: 150 },
  {
    field: 'used', headerName: 'Использована', width: 200,
    renderCell: ({ id, value }) => <UsedButton rfid={id} used={value} />
  },
  { field: 'clientName', headerName: 'Клиент', width: 200 },

  { field: 'manufacturerName', headerName: 'Производитель', width: 200 },
  { field: 'productName', headerName: 'Продукт', width: 200 },
]

export default function ClaimedLabels({ title }) {

  const [labels, labelsLoaded] = useCollection('claimedLabels')
  const [manufacturers, manufacturersLoaded] = useCollection('manufacturers')
  const [products, productsLoaded] = useCollection('products')
  const [clients, clientsLoaded] = useCollection('clients')

  const labelsExtra = useMemo(() => objectMap(labels, label => ({
    ...label,
    manufacturerName: manufacturers[label.manufacturer]?.name,
    productName: products[label.product]?.name,
    clientName: clients[label.client]?.name,
  })), [labels, clients, products, manufacturers])

  return <>
    <CollectionDataGrid
      collectionName={title}
      collection={labelsExtra}
      columns={columns}
      loading={!labelsLoaded || !clientsLoaded || !productsLoaded || !manufacturersLoaded}
    />
  </>

}